import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Yard Zone (post-production storage area)
 */
export interface StructureCastYardZone {
  id: string;
  name: string;
  area: string; // "north", "south", "west"
  x: number; // position on yard map (0-100 %)
  y: number;
  width: number;
  height: number;
  capacity: number;
  surfaceType: string; // "gravel", "concrete", "grass"
  status: "open" | "full" | "reserved";
  createdAt: string;
  updatedAt: string;
}

const mockStructureCastYardZonesData: StructureCastYardZone[] = [
  // North area — top row
  {
    id: "sc-yz-1",
    name: "Zone A",
    area: "north",
    x: 2,
    y: 4,
    width: 22,
    height: 28,
    capacity: 8,
    surfaceType: "gravel",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-yz-2",
    name: "Zone B",
    area: "north",
    x: 26,
    y: 4,
    width: 22,
    height: 28,
    capacity: 8,
    surfaceType: "gravel",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-yz-3",
    name: "Zone C",
    area: "north",
    x: 50,
    y: 4,
    width: 22,
    height: 28,
    capacity: 6,
    surfaceType: "gravel",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  // South area
  {
    id: "sc-yz-4",
    name: "Zone D",
    area: "south",
    x: 2,
    y: 38,
    width: 22,
    height: 28,
    capacity: 8,
    surfaceType: "gravel",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-yz-5",
    name: "Zone E",
    area: "south",
    x: 26,
    y: 38,
    width: 22,
    height: 28,
    capacity: 6,
    surfaceType: "gravel",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-yz-6",
    name: "Staging",
    area: "south",
    x: 2,
    y: 70,
    width: 30,
    height: 26,
    capacity: 10,
    surfaceType: "gravel",
    status: "reserved",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  // West area — right side
  {
    id: "sc-yz-7",
    name: "Zone F",
    area: "west",
    x: 74,
    y: 4,
    width: 24,
    height: 30,
    capacity: 6,
    surfaceType: "grass",
    status: "open",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
  {
    id: "sc-yz-8",
    name: "Zone G",
    area: "west",
    x: 74,
    y: 38,
    width: 24,
    height: 30,
    capacity: 8,
    surfaceType: "gravel",
    status: "full",
    createdAt: "2025-12-01T00:00:00.000Z",
    updatedAt: "2026-01-06T00:00:00.000Z",
  },
];

export const mockStructureCastYardZones: StructureCastYardZone[] = mockStructureCastYardZonesData;

export const createMockStructureCastYardZoneStore = () =>
  new MockServiceStore<StructureCastYardZone>({
    mockData: mockStructureCastYardZones,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-yard-zones",
  });

export default mockStructureCastYardZones;
